













import Vue from "vue";
import DemandInput from "@/components/DemandInput.vue";
import DemandRow from "@/components/DemandRow.vue";
import Component from "vue-class-component";
import { Getter } from "vuex-class";
import { StoreGetter } from "@/store";
import { Dictionary } from "lodash";
import { RequiredItem } from "@/game-types/RequiredItem";

@Component({
  components: {
    DemandInput,
    DemandRow
  }
})
export default class Demands extends Vue {
  @Getter(StoreGetter.getActiveDemands)
  private activeDemands!: Dictionary<RequiredItem>;
}
